/**
 *  EDAP events
 */

const actionlocation = 'linkpiles-module';

export const LINKPILES_CLICK_PREV = {
  name: 'nav.previous.click',
  data: {
    actionlocation
  }
};

export const LINKPILES_CLICK_NEXT = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const CAROUSEL_LINKPILES_REGION_LINK_CLICK = {
  name: 'region.link.click',
  data: {
    actionlocation
  }
};

export const LINKPILES_REGION_LINK_CLICK = ({ lbsId }) => ({
  name: 'region.link.click',
  data: {
    actionlocation,
    eventlbsuuid: lbsId
  }
});

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};